import types from '../mutation-types';
import CustomSlaReportsAPI from '../../api/customSlaReports';
import { downloadCsvFile } from 'dashboard/helper/downloadHelper';

export const state = {
  metrics: {
    byAgent: [],
    byTeam: [],
    byPolicy: [],
    unassigned: {},
    general: {},
    teamsAvailable: false,
  },
  conversations: {
    records: [],
    count: 0,
    currentPage: 1,
  },
  uiFlags: {
    isFetchingMetrics: false,
    isFetchingConversations: false,
  },
};

export const getters = {
  getMetrics(_state) {
    return _state.metrics;
  },
  getConversations(_state) {
    return _state.conversations;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  getMetrics: async function getMetrics({ commit }, params) {
    commit(types.SET_CUSTOM_SLA_REPORTS_UI_FLAG, { isFetchingMetrics: true });
    try {
      const response = await CustomSlaReportsAPI.getMetrics(params);
      commit(types.SET_CUSTOM_SLA_REPORTS_METRICS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CUSTOM_SLA_REPORTS_UI_FLAG, {
        isFetchingMetrics: false,
      });
    }
  },
  getConversations: async function getConversations({ commit }, params) {
    commit(types.SET_CUSTOM_SLA_REPORTS_UI_FLAG, {
      isFetchingConversations: true,
    });
    try {
      const response = await CustomSlaReportsAPI.getConversations(params);
      commit(types.SET_CUSTOM_SLA_REPORTS_CONVERSATIONS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CUSTOM_SLA_REPORTS_UI_FLAG, {
        isFetchingConversations: false,
      });
    }
  },
  download(_, params) {
    return CustomSlaReportsAPI.download(params).then(response => {
      downloadCsvFile(params.fileName, response.data);
    });
  },
};

export const mutations = {
  [types.SET_CUSTOM_SLA_REPORTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CUSTOM_SLA_REPORTS_METRICS](
    _state,
    {
      by_agent: byAgent,
      by_team: byTeam,
      by_policy: byPolicy,
      unassigned,
      general,
      teams_available: teamsAvailable,
    }
  ) {
    _state.metrics = {
      byAgent: byAgent || [],
      byTeam: byTeam || [],
      byPolicy: byPolicy || [],
      unassigned: unassigned || {},
      general: general || {},
      teamsAvailable: !!teamsAvailable,
    };
  },
  [types.SET_CUSTOM_SLA_REPORTS_CONVERSATIONS](_state, { payload, meta }) {
    _state.conversations = {
      records: payload || [],
      count: meta?.count || 0,
      currentPage: meta?.current_page || 1,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
